import React from "react";
import PlatformVersionCard from "./PlatformVersionCard";

const AppVersionConfig = () => {
  return (
    <div className="p-8">
      <div className="max-w-6xl mx-auto">
        <PlatformVersionCard platform="android" />
      </div>
    </div>
  );
};

export default AppVersionConfig;
